import { render, staticRenderFns } from "./CantidadAct.vue?vue&type=template&id=5af4bef3&scoped=true"
import script from "./CantidadAct.vue?vue&type=script&lang=js"
export * from "./CantidadAct.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CantidadAct.vue?vue&type=style&index=1&id=5af4bef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4bef3",
  null
  
)

export default component.exports